import moment from "moment";
import store from "../store";
import { hex_md5 } from "./md5";
import { getAreaTrees } from "../api/area";
import { getDepartmentTrees } from "../api/department";
import { getRoleList } from "../api/role";
import param from "../../static/config/param";
import common from "../../static/i18n/common.json";
const method = {
  browserLanguage() {
    let language = navigator.browserLanguage
      ? navigator.browserLanguage
      : navigator.language;
    language = language.toLowerCase().replace("-", "");
    switch (language) {
      case "zhcn":
        language = "zh";
        break;
      default:
        language = "en";
        break;
    }
    store.commit("SET_LANGUAGE", language);
    //保存日期格式
    this.setTimeFormat();
  },
  updateLanguage(language) {
    store.commit("SET_LANGUAGE", language);
    //保存日期格式
    this.setTimeFormat();
  },
  setTimeFormat() {
    let timeFormat = "";
    switch (store.state.language) {
      case "zh":
        timeFormat = "YYYY-MM-DD HH:mm:ss";
        break;
      default:
        timeFormat = "DD-MM-YYYY HH:mm:ss";
        break;
    }
    store.commit("SET_TIMEFORMAT", timeFormat);
  },
  /**
   * 自定义函数名：PrefixZero
   * @param num： 被操作数
   * @param n： 固定的总位数
   */
  prefixZero(num, n) {
    return (Array(n).join(0) + num).slice(-n);
  },
  prefixInteger(num, length, isPrefix = false) {
    let value = "";
    let prefix = Array(length).join("0");
    if (isPrefix) {
      value = (prefix + num).slice(-length);
    } else {
      value = (num + prefix).slice(0, length);
    }
    return value;
  },
  //去除空格
  trim(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  //去除空格
  trim1(str) {
    return str.replace(/(^\s*)|(\s*$)/g, "").replace(/\n/g, "");
  },
  //是否为邮箱格式
  isEmail(value) {
    let isEmail = /^[a-z0-9A-Z]+[-|a-z0-9A-Z._]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
      this.trim(value)
    );
    return isEmail;
  },
  //是否为手机号（带国家代码）
  isPhone(value) {
    let isPhone = /^[1-9][0-9]{0,3}-[0-9]{6,11}$/.test(this.trim(value));
    return isPhone;
  },
  //是否为手机号（不带国家代码）
  isPhone1(value) {
    let isPhone = /^[0-9]{8,11}$/.test(this.trim(value));
    return isPhone;
  },
  //根据定义的数组的值，获取名称
  constantLabel(value, list) {
    let text = "";
    let one = list.find((x) => x.value == value);
    if (one) text = one.label;
    return text;
  },
  addScript(src) {
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.src = src;
    document.body.appendChild(s);
  },
  getActive(key) {
    let active = "";
    if (param.sidebarInactive.indexOf(key) == -1) {
      let item = param.sidebarActive.find((x) => x.range.indexOf(key) != -1);
      if (item) {
        active = item.active;
      } else {
        active = key;
      }
    }

    return active;
  },
  //详情返回
  resetModule(from, to) {
    let value = false;

    let leave = from.path.replace("/", "");
    let enter = to.path.replace("/", "");
    let one = param.sidebarActive.find((x) => x.active == enter);
    if (one == undefined || one.range.indexOf(leave) == -1) {
      value = true;
    }

    return value;
  },
  //分页
  computePages(limit, count, page) {
    let firstPage = 0;
    let lastPage = 0;
    let pages = parseInt(count / limit) + (count % limit != 0 ? 1 : 0);

    if (pages > 10) {
      if (page > 6) {
        if (pages >= page + 4) {
          lastPage = page + 4;
        } else {
          lastPage = pages;
        }
      } else {
        lastPage = 10;
      }
    } else {
      lastPage = pages;
    }

    if (page > 5) {
      firstPage = page - 5;
    } else {
      firstPage = 1;
    }

    return {
      total: lastPage * limit,
      firstPage: firstPage,
      lastPage: lastPage,
    };
  },
  getLastOnes(data, limit, firstPage, list) {
    let length = data.length / limit + (data.length % limit != 0 ? 1 : 0);

    for (var i = 0; i < length - 1; i++) {
      let one = {
        page: firstPage + i,
        _id: "",
      };
      if (i != 0) {
        one._id = data[i * limit - 1]._id;
      }

      if (list.find((x) => x.page == one.page) == undefined) {
        //list中不存在该页的lastOne
        list.push(one);
      }
    }

    return list;
  },
  getTable(data, currentPage, firstPage, limit) {
    let begin = (currentPage - firstPage) * limit;
    let end = begin + limit > data.length ? data.length : begin + limit;
    let table = data.slice(begin, end);
    return table;
  },
  getLastOne(list, firstPage) {
    let lastOne = "";
    let one = list.find((x) => x.page == firstPage);
    if (one != undefined) {
      lastOne = one._id;
    }
    return lastOne;
  },
  //数组转为树形结构
  buildTree(list, ids) {
    let temp = {};
    let tree = [];
    list.map(function(x) {
      if (ids.includes(x._id)) {
        x.parent = null;
      }
    });
    for (let i in list) {
      temp[list[i]._id] = list[i];
    }
    for (let i in temp) {
      if (temp[i].parent) {
        if (!temp[temp[i].parent].children) {
          temp[temp[i].parent].children = new Array();
        }
        temp[temp[i].parent].children.push(temp[i]);
      } else {
        tree.push(temp[i]);
      }
    }
    return tree;
  },
  //树形结构转数组
  treeToList(tree, list) {
    var list = list || [];
    for (let i = 0; i < tree.length; i++) {
      list.push(tree[i]);
      if (tree[i].hasOwnProperty("children") && tree[i].children.length > 0) {
        this.treeToList(tree[i].children, list);
      }
    }
    return list;
  },
  sprintf() {
    if (arguments.length == 0) return null;
    var str = arguments[0];
    for (var i = 1; i < arguments.length; i++) {
      var re = new RegExp("\\{" + (i - 1) + "\\}", "gm");
      str = str.replace(re, arguments[i]);
    }
    return str;
  },
  getAreaTrees(callback = function() {}) {
    getAreaTrees(store.state.areaIds)
      .then((res) => {
        store.commit(
          "SET_AREATREE",
          this.buildTree(res.data, store.state.areaIds)
        );
        //获取经纬度
        if (res.data.length > 0) {
          let location = res.data[0].location;
          if (
            location != undefined &&
            location.loc != undefined &&
            location.type != undefined &&
            location.loc.length == 2
          ) {
            store.commit("SET_LBS", location.loc);
          }
          callback();
        }
      })
      .catch((error) => {});
  },
  getDepartmentTrees() {
    getDepartmentTrees(store.state.departmentIds)
      .then((res) => {
        if (res.errno == 0) {
          store.commit(
            "SET_DEPARTMENTTREE",
            this.buildTree(res.data, store.state.departmentIds)
          );
        }
      })
      .catch((error) => {});
  },
  //字符串转16进制
  strToHexCharCode(str) {
    if (str === "") return "";
    var hexCharCode = [];
    for (var i = 0; i < str.length; i++) {
      hexCharCode.push(str.charCodeAt(i).toString(16));
    }
    return hexCharCode.join("");
  },
  //16进制转字符串
  hexCharCodeToStr(hexCharCodeStr) {
    var trimedStr = hexCharCodeStr.replace(/(^\s*)|(\s*$)/g, "");
    var rawStr =
      trimedStr.substr(0, 2).toLowerCase() === "0x"
        ? trimedStr.substr(2)
        : trimedStr;
    var len = rawStr.length;
    if (len % 2 !== 0) {
      // alert("Illegal Format ASCII Code!");
      return "";
    }
    var curCharCode;
    var resultStr = [];
    for (var i = 0; i < len; i = i + 2) {
      curCharCode = parseInt(rawStr.substr(i, 2), 16); // ASCII Code Value
      resultStr.push(String.fromCharCode(curCharCode));
    }
    return resultStr.join("");
  },
  macFormat(mac) {
    var temp = /[A-Fa-f0-9]{2}[A-Fa-f0-9]{2}[A-Fa-f0-9]{2}[A-Fa-f0-9]{2}[A-Fa-f0-9]{2}[A-Fa-f0-9]{2}/;
    let bleMac = temp.test(mac)
      ? mac.replace(/(.{2})/g, "$1:").substr(0, 17)
      : mac;
    return bleMac;
  },
  getAreaName(areaList) {
    let text = "";
    let list = areaList.length == 0 ? store.state.areaIds : areaList;
    let List = this.treeToList(store.state.areaTree, []);
    let one = List.find((x) => x._id == list[list.length - 1]);
    if (one != undefined) {
      text = one.name;
    }
    return text;
  },
  getDepartmentName(departmentList) {
    let text = "";
    let list =
      departmentList.length == 0 ? store.state.departmentIds : departmentList;
    let List = this.treeToList(store.state.departmentTree, []);
    let one = List.find((x) => x._id == list[list.length - 1]);
    if (one != undefined) {
      text = one.name;
    }
    return text;
  },
  mapLanguage(lan) {
    let language = "Local";
    if (lan == "zh") {
      language = "Chinese_Simplified";
    } else if (lan == "en") {
      language = "English";
    }
    return language;
  },
  coordinateSystem() {
    let text = "GCJ02";
    //谷歌地图
    if (store.state.mapType == "google") {
      text = "WGS-84";
    }
    return text;
  },
  timeFormat(time) {
    return moment(time).format(store.state.timeFormat);
  },
  listToGroup(list, count) {
    let data = [];
    for (let i = 0; i < Math.ceil(list.length / count); i++) {
      let begin = i * count;
      let end = begin + count > list.length ? list.length : begin + count;
      data.push(list.slice(begin, end));
    }
    return data;
  },
  //密码加密
  encryptPwd(pwd) {
    try {
      return hex_md5(pwd);
    } catch (err) {}
  },
  //权限是否在时间范围中
  getFontColor(info) {
    let now = new Date();
    let day = now.getDay();
    let weeks = new Array(
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday"
    );
    let beginTime = moment(info.beginTime)._d;
    let endTime = moment(info.endTime)._d;
    let fromTo =
      this.prefixInteger(now.getHours(), 2, true) +
      this.prefixInteger(now.getMinutes(), 2, true);
    let result =
      now >= beginTime &&
      now <= endTime &&
      fromTo >= info.timezone.fromTime &&
      fromTo <= info.timezone.toTime &&
      info[weeks[day]];
    return result ? "#1273ff" : now < beginTime ? "#f4ba00" : "#7d7e82";
  },
  //卡号格式化
  cardFormat(number) {
    let value = number;
    if (
      number.length == 12 &&
      number.lastIndexOf("0000") == number.length - 4
    ) {
      value = number.substring(0, 8);
    }
    return value;
  },
  //权限类型是否为每天可用
  isAvailableDaily(beginTime, endTime, weekValue) {
    let count = weekValue.filter((x) => !x);
    return (
      beginTime.getTime() == 0 &&
      endTime.getTime() == 4000000000000 &&
      count.length == 0
    );
  },
  termValidityFormat(dateFormat, beginTime, endTime) {
    return (
      moment(beginTime).format(dateFormat) +
      " ~ " +
      moment(endTime).format(dateFormat)
    );
  },
  //deviationHieght:列表高度偏差值，deviationRow:列表行高偏差值
  tableConfig(deviationHieght = 0, deviationRow = 0) {
    let height = store.state.tableHeight - deviationHieght;
    let config = {
      height: height,
      limit: parseInt((height - 40) / (40 + deviationRow)),
    };
    //系统配置参数：表格记录条数
    if (param.tableLimit != -1 && config.limit < param.tableLimit) {
      config.limit = param.tableLimit;
    }
    return config;
  },
  getTypeByModel(model) {
    let value = "";
    for (let key in param.ModelList) {
      let one = param.ModelList[key].model.find((x) => model.indexOf(x) == 0);
      if (one) {
        value = param.ModelList[key].key;
        break;
      }
    }
    return value;
  },
  getModelByType(list) {
    let value = [];
    param.ModelList.forEach((item) => {
      if (list.indexOf(item.key) != -1) {
        value = value.concat(item.model);
      }
    });
    return value;
  },
  getTypeByDeviceModelId(id) {
    let value = "";
    let one = store.state.deviceModelList.find((x) => x._id == id);
    if (one) {
      value = this.getTypeByModel(one.model);
    }
    return value;
  },
  getDeviceModelIdsByType(type) {
    let value = [];
    let list = this.getModelByType(type);
    store.state.deviceModelList.forEach(function(item) {
      if (list.includes(item.model)) {
        value.push(item._id);
      }
    }, this);
    return value;
  },
  //语言选项为当前语言与英文 挪威语
  languageList(list) {
    // let browserLanguage = store.state.browserLanguage;
    // return list.filter(x => ["en", browserLanguage,param.language].includes(x.value));
    return list;
  },
  getRoles(id) {
    getRoleList("")
      .then((res) => {
        //获取经纬度
        if (res.errno == 0) {
          store.commit("SET_ROLES", res.data);
        }
        let one = store.state.roles.find((x) => x._id == id);
        if (one) {
          let permission = JSON.parse(JSON.stringify(store.state.role));
          delete permission._id;
          delete permission.name;
          delete permission.description;
          delete permission.updateAt;
          //初始化数据
          for (let KEY in permission) {
            if (one.hasOwnProperty(KEY)) {
              if (KEY == "device") {
                let template = JSON.parse(JSON.stringify(permission[KEY][0]));
                one[KEY].map(function(x) {
                  let item = JSON.parse(JSON.stringify(template));
                  item.deviceModel = x.deviceModel;
                  for (let key in item) {
                    if (key != "deviceModel" && x.hasOwnProperty(key)) {
                      if (key == "permission") {
                        for (let k in item[key]) {
                          for (let m in item[key][k]) {
                            if (x[key][k] && x[key][k].hasOwnProperty(m)) {
                              item[key][k][m] = x[key][k][m];
                            }
                          }
                        }
                      } else {
                        item[key] = x[key];
                      }
                    }
                  }
                  permission[KEY].push(item);
                }, this);
              } else {
                for (let key in permission[KEY]) {
                  if (one[KEY].hasOwnProperty(key)) {
                    permission[KEY][key] = one[KEY][key];
                  }
                }
              }
            }
          }
          //去除模板device
          permission.device = permission.device.filter(
            (x) => x.deviceModel != ""
          );
          permission._id = store.state.role._id;
          permission.name = one.name;
          permission.description = one.description;
          store.commit("SET_ROLE", permission);
        }
      })
      .catch((error) => {});
  },
  getRoleName(row) {
    let text = "";
    let one = store.state.roles.find((x) => x._id == row.roleId);
    if (one) {
      text = one.name;
    } else {
      text = common[store.state.language].word.ordinaryUser;
    }
    return text;
  },
  getDepartmentIds(id) {
    let list = [];
    let departmentList = this.treeToList(store.state.departmentTree, []);
    let one = departmentList.find((x) => x._id == id);
    if (one) {
      let child = one;
      while (
        child._id != store.state.departmentIds[store.state.areaIds.length - 1]
      ) {
        list.unshift(child._id);
        child = departmentList.find((x) => x._id == child.parent);
      }
      list.unshift(store.state.departmentIds[store.state.areaIds.length - 1]);
      // list = JSON.parse(JSON.stringify(one.ancestors));
      // list.push(one._id);
    }
    return list;
  },
  getAreaIds(id) {
    let list = [];
    let areaList = this.treeToList(store.state.areaTree, []);
    let one = areaList.find((x) => x._id == id);
    if (one) {
      let child = one;
      while (child._id != store.state.areaIds[store.state.areaIds.length - 1]) {
        list.unshift(child._id);
        child = areaList.find((x) => x._id == child.parent);
      }
      list.unshift(store.state.areaIds[store.state.areaIds.length - 1]);
      // list = JSON.parse(JSON.stringify(one.ancestors));
      // list.push(one._id);
    }
    return list;
  },
  roleDevicePower(objId, isType = false) {
    let id = "";
    if (isType) {
      id = objId;
    } else {
      let deviceModel = store.state.deviceModelList.find((x) => x._id == objId);
      if (deviceModel) {
        id = deviceModel.deviceTypeId;
      }
    }
    let one = store.state.role.device.find((x) => x.deviceModel == id);
    if (one) {
      return one;
    } else {
      return param.role.device[0];
    }
  },
  //是否为数字
  isANumber(inputData) {
    //isNaN(inputData)不能判断空串或一个空格
    //如果是一个空串或是一个空格，而isNaN是做为数字0进行处理的，而parseInt与parseFloat是返回一个错误消息，这个isNaN检查不严密而导致的。
    if (parseFloat(inputData).toString() == "NaN") {
      //alert(“请输入数字……”);
      return false;
    } else {
      return true;
    }
  },
  roleDeviceModelIds() {
    let list = [];
    store.state.deviceModelList.map(function(x) {
      let one = store.state.role.device.find(
        (y) => y.deviceModel == x.deviceTypeId
      );
      if (one == undefined || one.find) {
        list.push(x._id);
      }
    }, this);
    return list;
  },
  getEndTime(startTime, increment) {
    let start = startTime.split(":");
    let hour = parseInt(start[1]) + (increment % 60) >= 60;
    let end =
      this.prefixZero(
        parseInt(start[0]) + parseInt(increment / 60) + (hour ? 1 : 0),
        2
      ) +
      ":" +
      this.prefixZero(
        parseInt(start[1]) + (increment % 60) + (hour ? -60 : 0),
        2
      );
    return end;
  },
};
export { method };



// WEBPACK FOOTER //
// ./src/utils/method.js